/*** IMPORTS FROM imports-loader ***/
var define = false;

window.APP.mq = {
  small: window.matchMedia(`screen and (max-width: calc(${window.APP.breakpoints.medium} - 1px))`),
  medium: window.matchMedia(`screen and (min-width: ${window.APP.breakpoints.medium})`),
  large: window.matchMedia(`screen and (min-width: ${window.APP.breakpoints.large})`),
  xlarge: window.matchMedia(`screen and (min-width: ${window.APP.breakpoints.xlarge})`),
  xxlarge: window.matchMedia(`screen and (min-width: ${window.APP.breakpoints.xxlarge})`),
  xxxlarge: window.matchMedia(`screen and (min-width: ${window.APP.breakpoints.xxlarge})`),
  w1280: window.matchMedia(`screen and (min-width: ${window.APP.breakpoints.w1280})`),
  w1366: window.matchMedia(`screen and (min-width: ${window.APP.breakpoints.w1366})`),
  w1440: window.matchMedia(`screen and (min-width: ${window.APP.breakpoints.w1440})`),
}

